import React from 'react'
import Header from '../components/Header'
import Icon from '../assest/bannericon.svg'
import ContactForm from '../components/ContactForm'
import Contact from '../components/Contact'
import Practice from '../components/Practice'
import Footer from '../components/Footer'

const ServicesPage = () => {
    const servicesArray = {
        divisionTitle: "Hizmetlerimiz",
        subDivision:[ 
            {
                subAreaTitle: "HUKUKİ KURUMSALLAŞMA"
            },{
                subAreaTitle: "SERMAYE PİYASALARINDA KORUNMAK"
            },{ 
                subAreaTitle: "SÖZLEŞMELER"
            },{
                subAreaTitle: "MODERN BELGELENDİRME SİSTEMLERİNİN HUKUKİ KORUNMAYA KATKILARI", 
            }
        ]
    }
    return (
<>
    <div className="w-full flex flex-col">
        <div className="w-full flex flex-col">
            <div className="w-full flex flex-col bg-background-icsayfa bg-[#1F2732] justify-center items-center">
                <Header />
                <div className="w-full flex flex-col justify-center items-center gap-5 py-20">
                    <div className="font-baslik text-4xl text-white">Hizmetlerimiz</div>
                    <img src={Icon} alt="" />
                </div>
            </div>
            <div className="w-full flex flex-col justify-center items-center">
                <Practice data={servicesArray} />
                <div className="w-full flex bg-[#1F2732] justify-center items-center">
                    <Contact />
                </div>
                <ContactForm />
            </div>
        </div>
    </div>
    <div className="relative w-full flex justify-center items-center flex-col bg-[#1F2732]">
        <Footer /> 
    </div>
</>
    )
}

export default ServicesPage
